module.exports = __webpack_public_path__ + "img/bookmarks-fill.0fd7acd7.svg";